import gql from "graphql-tag";
import { GET_CAR_DOCUMENTS_ERROR, GET_CAR_DOCUMENTS_START, GET_CAR_DOCUMENTS_SUCCESS } from "../constants";

export const GET_CAR_DOCUMENTS = gql`
  query getCarDocuments($userId: Int!, $listId: Int) {
    getCarDocuments(userId: $userId, listId: $listId) {
      id
      userId
      listId
      uploadFile
      category
      uploadedAt
      status
    }
  }
`;


export const getCarDocuments = (userId, listId) => async (dispatch) => {
  dispatch({ type: GET_CAR_DOCUMENTS_START });
  try {
    const response = await fetch("/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        query: `query getCarDocuments($userId: String!, $listId: Int) {\n  getCarDocuments(userId: $userId, listId: $listId) {\n    id\n    userId\n    listId\n    uploadFile\n    category\n    uploadedAt\n    status\n  }\n}`,
        variables: {
          userId: userId,
          listId: Number(listId),
        },
      }),
    });
    const result = await response.json();
    const carDocuments = result.data?.getCarDocuments || [];
    console.log(carDocuments,"carDocuments");
    dispatch({
      type: GET_CAR_DOCUMENTS_SUCCESS,
      payload: carDocuments,
    });
    return carDocuments;
  } catch (error) {
    dispatch({
      type: GET_CAR_DOCUMENTS_ERROR,
      error: error.message || "Failed to fetch car documents",
    });
    return [];
  }
};
